import { Component, OnInit, inject } from '@angular/core';
import { User } from '@core/auth/user';
import { Observable } from 'rxjs';
import { UserService } from '@core/auth/user.service';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { NavbarComponent } from '@layout/navbar/navbar.component';

import { FooterComponent } from '@layout/footer/footer.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [NavbarComponent, ToastComponent, RouterOutlet, FooterComponent],
})
export class AppComponent implements OnInit {
  public user$: Observable<User | undefined | null>;
  public show_navbar: boolean = true;
  public show_footer: boolean = true;

  private readonly userService = inject(UserService);
  private readonly routerService = inject(Router);

  constructor() {
    const userService = this.userService;

    this.user$ = userService.getUser$();
  }

  ngOnInit(): void {
    // If Navigation is finished, check if url starts with '/learningpage'
    this.routerService.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.routerService.url.startsWith('/learningpage')) {
          this.show_navbar = false;
          this.show_footer = false;
        }
      }
    });
  }
}
